import { Injectable } from '@angular/core';
import { getStorage, ref, getBlob, deleteObject, uploadBytes, getDownloadURL, listAll } from 'firebase/storage';
import 'firebase/storage';
import { lastValueFrom, Observable } from 'rxjs';
import * as JSZip from "jszip";

@Injectable({
    providedIn: 'root',
  })
export class GoogleStorageService {
  private readonly bucketName = 'allegati-commesse';
  //private readonly credentialsPath = path.join(__dirname, 'credentials', 'coopamico-evo-dd9091182bce.json');
  //private readonly credentialsPath = `./assets/credentials/coopamico-evo-dd9091182bce.json`;

  async uploadFileSanitaToGoogleStorage(file: File, fileName: string): Promise<void> {
    const storage = getStorage();
    
    const pathReference = ref(
        storage,
        'pratiche/sanita/'+fileName
      );
    const uploadTask =  await uploadBytes(pathReference,file).then(ok => {
      

    }).catch(error => {
      console.log(">>>> KO FILE");
    });
  }

  getFolderContents(codiceInfratel: String): Observable<{ blob: Blob, fileName: string }[]> {
    const altriFilePath = "pratiche/scuola/" + codiceInfratel + "/IN/FASE_3/altro";
    const storage = getStorage();
    const folderRef = ref(storage, altriFilePath);
  
    return new Observable<{ blob: Blob, fileName: string }[]>(observer => {
      // Listiamo tutti i file nella cartella
      listAll(folderRef)
        .then(async result => {
          const filesToReturn: { blob: Blob, fileName: string }[] = [];
  
          if (result.items.length === 1) {
            // Se c'è solo un file, scarichiamo e restituiamo solo quel file
            const fileRef = result.items[0];
            const fileUrl = await getDownloadURL(fileRef);
            const fileName = fileRef.name;  // Nome del file reale
  
            fetch(fileUrl)
              .then(response => response.blob())
              .then(blob => {
                // Aggiungiamo il singolo file alla lista dei file da restituire
                filesToReturn.push({ blob, fileName });
                observer.next(filesToReturn);  // Restituiamo il singolo file
                observer.complete();
              })
              .catch(error => {
                console.error("Errore nel download del file: ", error);
                observer.error(error);
              });
          } else {
            // Se ci sono più file, scarichiamo ogni file e lo restituiamo singolarmente
            const downloadPromises = result.items.map(async (fileRef) => {
              const fileUrl = await getDownloadURL(fileRef);
              const response = await fetch(fileUrl);
              const blob = await response.blob();
              const fileName = fileRef.name.split("/").pop();  // Otteniamo solo il nome del file senza il percorso
              filesToReturn.push({ blob, fileName });  // Aggiungiamo ogni file alla lista
            });
  
            // Attendiamo che tutti i file vengano scaricati
            await Promise.all(downloadPromises);
  
            // Restituiamo tutti i file come una lista
            observer.next(filesToReturn);
            observer.complete();
          }
        })
        .catch(error => {
          console.error("Errore nella lettura della cartella: ", error);
          observer.error(error);
        });
    });
  }

  
  downloadFolderContents(codiceInfratel: String): Observable<{ blob: Blob, fileName: string }> {
    const altriFilePath= "pratiche/scuola/"+codiceInfratel+"/IN/FASE_3/altro";
    const storage = getStorage();
    const folderRef = ref(storage, altriFilePath);
  
    return new Observable<{ blob: Blob, fileName: string }>(observer => {
      // Listiamo tutti i file nella cartella
      listAll(folderRef)
        .then(async result => {
          const zip = new JSZip();
  
          if (result.items.length === 1) {
            // Se c'è solo un file, scarichiamo e restituiamo il file singolo
            const fileRef = result.items[0];
            const fileUrl = await getDownloadURL(fileRef);
            const fileName = fileRef.name;  // Nome del file reale
  
            fetch(fileUrl)
              .then(response => response.blob())
              .then(blob => {
                observer.next({ blob, fileName });  // Restituiamo il blob con il nome del file reale
                observer.complete();
              })
              .catch(error => {
                console.error("Errore nel download del file: ", error);
                observer.error(error);
              });
          } else {
            // Se ci sono più file, li aggiungiamo allo ZIP
            const downloadPromises = result.items.map(async (fileRef) => {
              const fileUrl = await getDownloadURL(fileRef);
              const response = await fetch(fileUrl);
              const blob = await response.blob();
              const fileName = fileRef.name;
              zip.file(fileName, blob);  // Aggiungiamo ogni file allo zip
            });
  
            // Attendiamo che tutti i file vengano scaricati e zippati
            await Promise.all(downloadPromises);
  
            // Generiamo il file ZIP
            zip.generateAsync({ type: 'blob' })
              .then(content => {
                const zipFileName = codiceInfratel+'_altri_file.zip';  // Nome del file ZIP
                observer.next({ blob: content, fileName: zipFileName });  // Restituiamo lo ZIP con il nome
                observer.complete();
              })
              .catch(error => {
                console.error("Errore nella creazione dello ZIP: ", error);
                observer.error(error);
              });
          }
        })
        .catch(error => {
          console.error("Errore nella lettura della cartella: ", error);
          observer.error(error);
        });
    });
  }


  checkIfPraticaHasAltriFile(codiceInfratel: String): Observable<boolean> {
    const altriFilePath= "pratiche/scuola/"+codiceInfratel+"/IN/FASE_3/altro";

  const storage = getStorage();
  const folderRef = ref(storage, altriFilePath);

  return new Observable<boolean>(observer => {
    listAll(folderRef)
      .then(result => {
        if (result.items.length > 0 || result.prefixes.length > 0) {
          // La cartella esiste se ci sono file o sottocartelle
         // console.log(">>>> CARTELLA ESISTE!");
          observer.next(true);
        } else {
          // La cartella è vuota o non esiste
         // console.log(">>>> CARTELLA NON ESISTE O È VUOTA!");
          observer.next(false);
        }
        observer.complete();
      })
      .catch(error => {
        if (error.code === 'storage/object-not-found') {
          // La cartella non esiste
         // console.log(">>>> CARTELLA NON ESISTE!");
          observer.next(false);
          observer.complete();
        } else {
          // Gestione di eventuali altri errori
         // console.error(">>>> ERRORE NEL CONTROLLO DELLA CARTELLA: ", error);
          observer.error(error);
        }
      });
  });
    /* console.log(">>>> CONTROLLO SE FILE ESISTE LA CARTELLA ALTRO SU STORAGE: "+path);
    const storage = getStorage();
    const fileRef = ref(
      storage,
      path
    );
    return new Observable<boolean>(observer => {
      getDownloadURL(fileRef)
      .then(url => {
        console.log(">>>> CARTELLA ESISTE! ");

        observer.next(true);
        observer.complete();
      },
      error => {
        console.log(">>>> CARTELLA NON ESISTE! ");
        if (error.code === 'storage/object-not-found') {
          // Il file non esiste
          observer.next(false);
          observer.complete();
        } else {
          // Gestione degli altri errori
          observer.error(error);
        }
      }
    );
    }); */
  }

  checkIfFileExists(path: string): Observable<boolean> {
    console.log(">>>> CONTROLLO SE FILE ESISTE SU STORAGE: "+path);
    // Ottieni il riferimento al file sullo storage
    const storage = getStorage();
    const fileRef = ref(
      storage,
      path
    );
    return new Observable<boolean>(observer => {
      getDownloadURL(fileRef)
      .then(url => {
        console.log(">>>> FILE ESISTE! ");

        observer.next(true);
        observer.complete();
      },
      error => {
        console.log(">>>> FILE NON ESISTE! ");
        if (error.code === 'storage/object-not-found') {
          // Il file non esiste
          observer.next(false);
          observer.complete();
        } else {
          // Gestione degli altri errori
          observer.error(error);
        }
      }
    );
    });
}

  async uploadFileCMTPianoTecnicoSanitaToGoogleStorage(file: File, fileName: string): Promise<void> {
    const storage = getStorage();
    
    const pathReference = ref(
        storage,
        'pratiche/sanita/CMT/'+fileName
      );
    const uploadTask =  await uploadBytes(pathReference,file).then(ok => {
      console.log(">>>> OK SALVATAGGIO FILE "+fileName);

    }).catch(error => {
      console.log(">>>> KO FILE");
    });
  }

  async uploadFileScuolaToGoogleStorage(file: File, fileName: string): Promise<void> {
    const storage = getStorage();
    
    const pathReference = ref(
        storage,
        'pratiche/scuola/'+fileName
      );
    const uploadTask =  await uploadBytes(pathReference,file).then(ok => {
      console.log(">>>> OK SALVATAGGIO FILE "+fileName);

    }).catch(error => {
      console.log(">>>> KO FILE");
    });
  }

  async uploadNTXToGoogleStorage(geoJson: string, codiceUnivocoInfratel: string): Promise<void> {
    const storage = getStorage();
    console.log("---> uploadNTXToGoogleStorage "+ codiceUnivocoInfratel);

    const pathReference = ref(
        storage,
        'pratiche/sanita/'+codiceUnivocoInfratel+"/ntx/ntxMODIFICATO.json"
      );
      console.log("---> pathReference");
      console.log(geoJson);
      try {
        const blob = new Blob([geoJson], { type: 'application/json' });
        const arrayBuffer = await new Response(blob).arrayBuffer();
        const bytes = new Uint8Array(arrayBuffer);

       // const bytes = new Uint8Array(Buffer.from(geoJson));
      //console.log(bytes); 

      const uploadTask =  await uploadBytes(pathReference,bytes).then(ok => {
        console.log(">>>> OK SALVATAGGIO FILE");

      }).catch(error => {
        console.log(">>>> KO FILE");
      });
      } catch (error) {
        console.log(error);
      }
      
  }

  
  async downloadFileFromGoogleStorage(codice_univoco_infratel: String, fileName: String): Promise<void> {
    const storage = getStorage();
    
    const pathReference = ref(
        storage,
        'pratiche/scuola/'+codice_univoco_infratel+"/"+fileName
      );
    getBlob(pathReference).then(ok => {
      console.log(">>>> OK DOWNLOAD FILE");
    
      return ok;
    }).catch(error => {
      console.log(">>>> KO DOWNLOAD FILE FILE");
    });
  }

 


  async downloadGeoJSONSanitaFromGoogleStorage(codice_univoco_infratel: String): Promise<void> {
    const storage = getStorage();
    
    const pathReference = ref(
        storage,
        'pratiche/sanita/'+codice_univoco_infratel+"/ntx/ntx.json"
      );
    getBlob(pathReference).then(ok => {
      console.log(">>>> OK DOWNLOAD GEO JSON PRATICA " + codice_univoco_infratel);

      return ok;
    }).catch(error => {
      console.log(">>>> KO DOWNLOAD GEO JSON PRATICA " + codice_univoco_infratel);
    });
  }
}
